const __WEBPACK_NAMESPACE_OBJECT__ = ng.common;